// removed by extract-text-webpack-plugin
module.exports = {"advertising":"advertising"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_advertising.scss
// module id = 74
// module chunks = 0